import api from '../config/api';

export const driverService = {
  // Get available ride requests for drivers
  async getAvailableRides() {
    try {
      const response = await api.get('/rides/available/requests');
      return response.data;
    } catch (error) {
      console.error('Get available rides error:', error);
      throw error;
    }
  },

  // Accept a ride request
  async acceptRide(rideId) {
    try {
      const response = await api.post('/rides/accept', { rideId });
      return response.data;
    } catch (error) {
      console.error('Accept ride error:', error);
      throw error;
    }
  },

  // Mark arrived at pickup
  async arriveAtPickup(rideId) {
    try {
      const response = await api.post('/rides/arrive', { rideId });
      return response.data;
    } catch (error) {
      console.error('Arrive error:', error);
      throw error;
    }
  },

  // Start ride (picked up passenger)
  async startRide(rideId) {
    try {
      const response = await api.post('/rides/start', { rideId });
      return response.data;
    } catch (error) {
      console.error('Start ride error:', error);
      throw error;
    }
  },

  // Complete a ride
  async completeRide(rideId) {
    try {
      const response = await api.post('/rides/complete', { rideId });
      return response.data;
    } catch (error) {
      console.error('Complete ride error:', error);
      throw error;
    }
  },

  // Cancel a ride
  async cancelRide(rideId) {
    try {
      const response = await api.post('/rides/cancel', { rideId });
      return response.data;
    } catch (error) {
      console.error('Cancel ride error:', error);
      throw error;
    }
  },

  // Update driver availability status
  async updateAvailability(isOnline) {
    try {
      const response = await api.post('/driver/availability', { isOnline });
      return response.data;
    } catch (error) {
      console.error('Update availability error:', error);
      throw error;
    }
  },

  // Update driver location
  async updateLocation(latitude, longitude) {
    try {
      const response = await api.post('/driver/location', { latitude, longitude });
      return response.data;
    } catch (error) {
      console.error('Update location error:', error);
      throw error;
    }
  },

  // Get driver's current ride
  async getCurrentRide() {
    try {
      const response = await api.get('/driver/current-ride');
      return response.data;
    } catch (error) {
      console.error('Get current ride error:', error);
      throw error;
    }
  },

  // Get driver statistics
  async getDriverStats() {
    try {
      const response = await api.get('/driver/stats');
      return response.data;
    } catch (error) {
      console.error('Get driver stats error:', error);
      throw error;
    }
  },

  // Get earnings
  async getEarnings(period = 'week') {
    try {
      const response = await api.get(`/driver/earnings?period=${period}`);
      return response.data;
    } catch (error) {
      console.error('Get earnings error:', error);
      throw error;
    }
  },

  // Update vehicle info
  async updateVehicle(data) {
    try {
      const response = await api.put('/driver/vehicle', data);
      return response.data;
    } catch (error) {
      console.error('Update vehicle error:', error);
      throw error;
    }
  },

  // Get ride history
  async getRideHistory(page = 1, limit = 20) {
    try {
      const response = await api.get(`/rides/history?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Get ride history error:', error);
      throw error;
    }
  },

  // Get wallet balance and earnings summary
  async getWallet() {
    try {
      const response = await api.get('/driver/wallet');
      return response.data;
    } catch (error) {
      console.error('Get wallet error:', error);
      throw error;
    }
  },

  // Cash out driver balance
  async cashOut(amount) {
    try {
      const response = await api.post('/driver/cash-out', { amount });
      return response.data;
    } catch (error) {
      console.error('Cash out error:', error);
      throw error;
    }
  },

  // Get driver profile (vehicle info + documents)
  async getProfile() {
    try {
      const response = await api.get('/driver/profile');
      return response.data;
    } catch (error) {
      console.error('Get profile error:', error);
      throw error;
    }
  },

  // Update driver profile (vehicle info)
  async updateProfile(data) {
    try {
      const response = await api.put('/driver/profile', data);
      return response.data;
    } catch (error) {
      console.error('Update profile error:', error);
      throw error;
    }
  },

  // Get driver documents
  async getDocuments() {
    try {
      const response = await api.get('/driver/documents');
      return response.data;
    } catch (error) {
      console.error('Get documents error:', error);
      throw error;
    }
  },

  // Upload a document
  async uploadDocument(type, fileName, fileData) {
    try {
      const response = await api.post('/driver/documents', { type, fileName, fileData });
      return response.data;
    } catch (error) {
      console.error('Upload document error:', error);
      throw error;
    }
  },

  // Delete a document
  async deleteDocument(id) {
    try {
      const response = await api.delete(`/driver/documents/${id}`);
      return response.data;
    } catch (error) {
      console.error('Delete document error:', error);
      throw error;
    }
  },

  // Get transaction history
  async getTransactions(page = 1, limit = 20, type) {
    try {
      let url = `/driver/transactions?page=${page}&limit=${limit}`;
      if (type) url += `&type=${type}`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Get transactions error:', error);
      throw error;
    }
  },
};
